import { TransactionsResponse } from '@/interfaces/transactions';
import { Response } from '@/interfaces/api';
import api from '~/api/client';
import { CONSUMER_API_PATH } from './config';

export function getTransactions(
  abortController: AbortController,
  loanNumber: string,
  params: Record<string, unknown> | URLSearchParams = {},
): Response<TransactionsResponse> {
  return api.client.get(
    `${CONSUMER_API_PATH}/transactions/${loanNumber}/`,
    {
      params,
      signal: abortController?.signal ?? undefined,
    }
  );
}

export function getTransactionTypes() {
  return api.client.get(`${CONSUMER_API_PATH}/transaction-types`);
}
